/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Sanitized metadata bound to the LiteLLM virtual key and request.
 */
export type LiteLLMRequestData = {
  userApiKeyAlias?: string | undefined;
  userApiKeyEndUserId?: string | undefined;
  userApiKeyHash?: string | undefined;
  userApiKeyOrgId?: string | undefined;
  userApiKeyTeamAlias?: string | undefined;
  userApiKeyTeamId?: string | undefined;
  userApiKeyUserEmail?: string | undefined;
  userApiKeyUserId?: string | undefined;
};

/** @internal */
export type LiteLLMRequestData$Outbound = {
  user_api_key_alias?: string | undefined;
  user_api_key_end_user_id?: string | undefined;
  user_api_key_hash?: string | undefined;
  user_api_key_org_id?: string | undefined;
  user_api_key_team_alias?: string | undefined;
  user_api_key_team_id?: string | undefined;
  user_api_key_user_email?: string | undefined;
  user_api_key_user_id?: string | undefined;
};

/** @internal */
export const LiteLLMRequestData$outboundSchema: z.ZodMiniType<
  LiteLLMRequestData$Outbound,
  LiteLLMRequestData
> = z.pipe(
  z.object({
    userApiKeyAlias: z.optional(z.string()),
    userApiKeyEndUserId: z.optional(z.string()),
    userApiKeyHash: z.optional(z.string()),
    userApiKeyOrgId: z.optional(z.string()),
    userApiKeyTeamAlias: z.optional(z.string()),
    userApiKeyTeamId: z.optional(z.string()),
    userApiKeyUserEmail: z.optional(z.string()),
    userApiKeyUserId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userApiKeyAlias: "user_api_key_alias",
      userApiKeyEndUserId: "user_api_key_end_user_id",
      userApiKeyHash: "user_api_key_hash",
      userApiKeyOrgId: "user_api_key_org_id",
      userApiKeyTeamAlias: "user_api_key_team_alias",
      userApiKeyTeamId: "user_api_key_team_id",
      userApiKeyUserEmail: "user_api_key_user_email",
      userApiKeyUserId: "user_api_key_user_id",
    });
  }),
);

export function liteLLMRequestDataToJSON(
  liteLLMRequestData: LiteLLMRequestData,
): string {
  return JSON.stringify(
    LiteLLMRequestData$outboundSchema.parse(liteLLMRequestData),
  );
}
